import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const [permissions, setPermissions] = useState({
    view: false,
    edit: false,
    write: false,
  });
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const users = JSON.parse(localStorage.getItem("users") || "[]");

    // prevent duplicate usernames
    if (users.some((u) => u.username === username)) {
      alert("User already exists!");
      return;
    }

    const newUser = {
      username,
      password,
      role,
      permissions,
    };

    users.push(newUser);
    localStorage.setItem("users", JSON.stringify(users));

    alert("✅ User added successfully!");
    navigate("/role-master"); // 🔹 Go to Role Master after adding
  };

  const togglePermission = (perm) => {
    setPermissions((prev) => ({ ...prev, [perm]: !prev[perm] }));
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", paddingTop: "50px" }}>
      <form
        onSubmit={handleSubmit}
        style={{
          width: "400px",
          background: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "30px",
        }}
      >
        <h2 style={{ textAlign: "center", color: "#2e7d32" }}>Add New User</h2>

        <label>Username</label>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          style={{
            width: "100%",
            padding: "8px",
            margin: "6px 0 12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        />

        <label>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{
            width: "100%",
            padding: "8px",
            margin: "6px 0 12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        />

        <label>Role</label>
        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          style={{
            width: "100%",
            padding: "8px",
            margin: "6px 0 12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        >
          <option value="user">User</option>
          <option value="admin">Admin</option>
          <option value="manager">Manager</option>
        </select>

        <div style={{ marginTop: "12px" }}>
          <label>Permissions:</label>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "8px" }}>
            {["view", "edit", "write"].map((perm) => (
              <label key={perm}>
                <input
                  type="checkbox"
                  checked={permissions[perm]}
                  onChange={() => togglePermission(perm)}
                />{" "}
                {perm.charAt(0).toUpperCase() + perm.slice(1)}
              </label>
            ))}
          </div>
        </div>

        <button
          type="submit"
          style={{
            width: "100%",
            background: "linear-gradient(to right, #43a047, #66bb6a)",
            border: "none",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
            marginTop: "20px",
            cursor: "pointer",
          }}
        >
          ➕ Add User
        </button>
      </form>
    </div>
  );
}
